// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-3ib2hn2Q clearfix","list":"list-1rA5PYBx"};